import React, {Component} from 'react';
import isEmpty from 'is-empty';
import {RealNumberRounded} from '../../../utils/NumeralParts';
import ArrayFormatters from '../../../utils/arrayFormatters';

class SearchSummary extends Component{
  constructor(props) {
    super(props)

    this.renderMinAmountSummary = this.renderMinAmountSummary.bind(this)
    this.renderMaxAmountSummary = this.renderMaxAmountSummary.bind(this)
  }

  renderMinAmountSummary() {
    if (!isEmpty(this.props.minAmount)) {
      return (
        <div class="ds-data">
          <strong class="dataName">Minimum Amount:</strong>
          <p class="data">{isEmpty(this.props.minAmount) ? "---" : `₱${RealNumberRounded({ number: this.props.minAmount})}`}</p>
        </div>
      )
    }
  }

  renderMaxAmountSummary() {
    if (!isEmpty(this.props.maxAmount)) {
      return (
        <div class="ds-data">
          <strong class="dataName">Maximum Amount:</strong>
          <p class="data">{isEmpty(this.props.maxAmount) ? "---" : `₱${RealNumberRounded({ number: this.props.maxAmount})}`}</p>
        </div>
      )
    }
  }

  render() {
    const {keyword, regions} = this.props

    return (
      <div className="_padding--small">
        <div className="search-summary">
          <div className="result-summary _padding--large">
            <h4 className="copy">
              {`${this.props.totalCount.toLocaleString()} results for ${isEmpty(keyword) ? "Projects" : `"${keyword}"`} in ${ArrayFormatters.toWords(regions) || "All Regions"}`}
            </h4>
            <div class="ds-dataSet _parallelData">
              {this.renderMinAmountSummary()}
              {this.renderMaxAmountSummary()}
            </div>
          </div>
          <div>
            <button id="get-alerts-btn" className="ds-btn" onClick={this.props.onClick}>
              Get alerts for this search
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default SearchSummary;



// WEBPACK FOOTER //
// ./src/features/projectFinder/components/SearchSummary.js